import { jsx as _jsx } from "react/jsx-runtime";
import { Select as HeroSelect } from '@heroui/react';
export const Select = (props) => {
    return _jsx(HeroSelect, { ...props });
};
export default Select;
//# sourceMappingURL=Select.js.map